const A = "en-US", _ = "/api/";
export {
  A as API_BASE_LANG,
  _ as API_BASE_URL
};
